import {
  CategoryType,
  KeywordPerformanceScores
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentServerProxy/types';
import { TimeSeriesPoint } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/hooks/classes/TimeSeriesData';
import { METRICTYPE } from 'src/utils/entityDefinitions';

export type Category = { id: number; name: string };
export type CategoryValue = [string, number];
export type ContentScoreByCategoryData = {
  categories: Category[];
  data: CategoryValue[];
  metricType: METRICTYPE;
  type: 'column' | string;
};

export enum KeywordFilter {
  Usage = 'Usage', // card group 1 (Usage)
  KeywordBenchmark = 'KeywordBenchmark', // new option, card group 1 (Usage)
  LowUsage = 'LowUsage', // new option, card group 1 (Usage)
  Productivity = 'Productivity', // card group 2 (Productivity)
  UnProductiveKeywords = 'UnProductiveKeywords', // new option, card group 2 (Productivity)
  LowProductivity = 'LowProductivity', // new option, card group 2 (Productivity)
  Popularity = 'Popularity', // card group 3 (Popularity), aka "Keyword Search Volume"
  PopularityBenchmark = 'PopularityBenchmark', // new option, card group 3 (Popularity)
  LowPopularity = 'LowPopularity' // new option, card group 3 (Popularity)
}

export interface MetricFormatterProps {
  showFullValue: boolean;
  decimalPlaces: number;
  valueMetricType: METRICTYPE;
}

export interface GaugeData {
  percentage?: number;
  change?: number;
  value: number;
  valueSuffix?: string;
  filterKey: KeywordFilter;
  valueMetricFormatter?: MetricFormatterProps;
}

export interface KeywordPerformanceGaugeData {
  gaugeData: GaugeData[];
  mainScores: KeywordPerformanceScores;
  comparisonScores: KeywordPerformanceScores;
}

export type BarChartData = {
  chartData: ContentScoreByCategoryData[];
  categoryType?: CategoryType;
};

export interface ContentSplineChartData {
  chartData: {
    primaryMetrics: TimeSeriesPoint[];
    secondaryMetrics: TimeSeriesPoint[];
  };
  legendData: {
    primaryLegendMetric: number;
    secondaryLegendMetric: number;
    percentChange: number;
  };
  averageKeywordCount?: number;
}

// we should just have tiles not include a KeywordFilter if they are not clickable so we can use this to determine if a tile is clickable
export const unClickableTiles = [
  KeywordFilter.LowUsage,
  KeywordFilter.LowProductivity,
  KeywordFilter.LowPopularity,
  KeywordFilter.KeywordBenchmark,
  KeywordFilter.PopularityBenchmark
];
